<template>
	<div id="top">
		<el-menu theme="dark" class="el-menu-demo test" mode="horizontal">
			<span>运动世界校园</span>

			<el-dropdown v-show="user.name" @command="loginOut">
				<span class="el-dropdown-link">
					{{user.name}},欢迎您
					<i class="el-icon-caret-bottom el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown" @command="loginOut">
					<el-dropdown-item>退出登录</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>

			<template v-if="$util.isComplexVersion">
				<el-menu-item index="2" v-show="user.name">
					<router-link :to="'/yunying'">运营管理</router-link>
				</el-menu-item>
				<el-menu-item index="1" v-show="user.name">
					<router-link :to="'/xiaoyuan'">校园管理</router-link>
				</el-menu-item>
				<el-menu-item index="3" v-show="user.name">
					<router-link :to="'/user'">用户管理</router-link>
				</el-menu-item>
				<el-menu-item index="4" v-show="user.name">
					<router-link :to="'/secretary'">小秘书</router-link>
				</el-menu-item>
			</template>
		</el-menu>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex'

	export default {
		computed: mapState({ user: state => state.user }),

		methods: {
			...mapActions(['SIGNOUT']),
			loginOut() {

				// 退出登录
				this.$http({
					method: 'GET',
					url: this.$util.domain + '/adminapi/v1/user/logout'
				}).then(response => {
					if (response.data.error === 10000) {
						this.SIGNOUT();
						this.$router.replace({ path: '/login' })
					}
				}, (response) => {
					console.log('失败');
				})

			}
		}
	}
</script>

<style>
	#top {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 200;
	}

	#top .admin {
		float: right;
	}

	#top .el-menu-item {
		float: right;
	}

	#top span {
		color: #c0ccda;
		line-height: 60px;
		padding-left: 24px;
	}

	#top .is-active a {
		color: #20a0ff;
	}

	#top .el-dropdown {
		float: right;
		margin-right: 20px;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// Top.vue?39989ecc